import { analyticsApi } from '../api/analyticsApi';

let _sessionId = null;
let _userId = null;

function generateSessionId() {
  return `sess_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;
}

const analyticsTracker = {
  init(userId) {
    _userId = userId || '';
    if (!_sessionId) {
      _sessionId = generateSessionId();
      analyticsApi.startSession(_sessionId);
    }
  },

  getSessionId() {
    if (!_sessionId) {
      _sessionId = generateSessionId();
    }
    return _sessionId;
  },

  trackEvent(eventType, feature, category = 'action', metadata = {}) {
    if (!_sessionId) {
      _sessionId = generateSessionId();
    }
    const payload = {
      sessionId: _sessionId,
      eventType,
      feature,
      category,
      metadata: { ...metadata, userId: _userId || '' },
    };
    analyticsApi.trackEvent(payload);
  },

  trackPageView(pageName) {
    this.trackEvent('page_view', pageName, 'navigation');
  },

  trackFeatureUse(feature, action, metadata = {}) {
    this.trackEvent('feature_use', feature, 'action', { action, ...metadata });
  },

  trackSearch(query, feature = 'ask_stewie', category = 'general') {
    this.trackEvent('search', feature, 'content', { questionText: query, category });
  },

  trackCaseCreated(feature, caseType, metadata = {}) {
    this.trackEvent('case_created', feature, 'content', { caseType, ...metadata });
  },

  // === AskStewie specific ===
  trackQuestionAsked(question, feature = 'ask_stewie', category = 'general') {
    this.trackEvent('question_asked', feature, 'content', { questionText: question, category });
  },

  trackAnswerGenerated(question, confidenceScore = null, feature = 'ask_stewie') {
    this.trackEvent('answer_generated', feature, 'content', { questionText: question, confidenceScore });
  },

  trackAnswerHelpful(question, helpful, feature = 'ask_stewie') {
    const eventType = helpful ? 'answer_helpful_yes' : 'answer_helpful_no';
    this.trackEvent(eventType, feature, 'feedback', { questionText: question });
  },

  // === Job Briefing specific ===
  trackJobBriefingStarted() {
    this.trackEvent('job_briefing_started', 'job_briefing', 'action');
  },

  trackJobBriefingStepCompleted(stepNumber) {
    this.trackEvent('job_briefing_step_completed', 'job_briefing', 'action', { stepNumber });
  },

  trackJobBriefingCompleted() {
    this.trackEvent('job_briefing_completed', 'job_briefing', 'action');
  },

  trackJobBriefingExported() {
    this.trackEvent('job_briefing_exported', 'job_briefing', 'action');
  },

  // === Fact Finder specific ===
  trackFactFinderStarted(mode) {
    this.trackEvent('fact_finder_started', 'fact_finder', 'action', { mode });
  },

  trackFactFinderStepCompleted(mode, step) {
    this.trackEvent('fact_finder_step_completed', 'fact_finder', 'action', { mode, step });
  },

  trackFactFinderCompleted(mode) {
    this.trackEvent('fact_finder_completed', 'fact_finder', 'action', { mode });
  },

  trackFactFinderExportedPdf(mode) {
    this.trackEvent('fact_finder_exported_pdf', 'fact_finder', 'action', { mode });
  },

  // === Home page ===
  trackFeatureOpened(featureName) {
    this.trackEvent('feature_opened', 'home', 'navigation', { featureName });
  },

  endSession() {
    if (_sessionId) {
      analyticsApi.endSession(_sessionId);
      _sessionId = null;
    }
  },
};

export default analyticsTracker;
